import { axios } from '@/services/axios';

export const getUsers = async (currentCompany) => {
    const res = await axios.get(`/Users/${currentCompany}`);
    return res.data;
};